import React from "react";
import { FieldProps } from "formik";
import cx from "clsx";

export interface InputProps extends FieldProps {
  label?: string;
}

export default ({ label, field, form }: InputProps) => {
  const labelClasses = cx("custom-control-label");

  return (
    <div className="custom-control custom-switch mb-2">
      <input
        id={field.name}
        type="checkbox"
        className="custom-control-input"
        checked={!!field.value}
        onChange={({ target }) => form.setFieldValue(field.name, target.checked)}
      />
      <label className={labelClasses} htmlFor={field.name}>
        {label}
      </label>
    </div>
  );
};
